import {
  INJECT_EDIT_CONTEXT,
  INJECT_MUTATED_FIELDS_MAP,
  INJECT_PROVIDER_BLOCKS
} from "#blokkli/helpers/symbols";
import { inject, computed, watch, ref } from "#imports";
import { FIELD_MAPPING } from "#blokkli-build/runtime-options";
import { getActualBlock } from "#blokkli/helpers/runtimeHelpers";
function walkBlocks(matches, callback, mutatedOptions, mutatedFieldsMap, list) {
  if (!list) return;
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (!item) continue;
    if (!("bundle" in item) || !("uuid" in item)) continue;
    const mutatedOptionsForBlock = mutatedOptions[item.uuid] ?? {};
    const mappedItem = getActualBlock({
      ...item,
      options: { ...item.options, ...mutatedOptionsForBlock }
    });
    if (!mappedItem) continue;
    const callbackResult = callback(mappedItem);
    if (callbackResult === null || callbackResult === void 0) {
      continue;
    } else if (callbackResult.include) {
      matches.push(mappedItem);
    }
    if (callbackResult.continueChildren === false) {
      continue;
    }
    const nestedFieldMapping = FIELD_MAPPING[mappedItem.bundle];
    if (!nestedFieldMapping) continue;
    if (!mappedItem.props) continue;
    const propNames = Object.keys(nestedFieldMapping);
    for (const propName of propNames) {
      const fieldName = nestedFieldMapping[propName];
      const key = mappedItem.uuid + ":" + fieldName;
      const value = mutatedFieldsMap ? mutatedFieldsMap[key]?.list : mappedItem.props?.[propName];
      if (!value) continue;
      const valueAsArray = Array.isArray(value) ? value : [value];
      walkBlocks(
        matches,
        callback,
        mutatedOptions,
        mutatedFieldsMap,
        valueAsArray
      );
    }
  }
}
export function useBlokkliHelper() {
  const rootBlocks = inject(
    INJECT_PROVIDER_BLOCKS,
    null
  );
  const editContext = inject(INJECT_EDIT_CONTEXT, null);
  const mutatedOptions = ref({});
  const mutatedFields = inject(
    INJECT_MUTATED_FIELDS_MAP,
    null
  );
  if (editContext?.mutatedOptions) {
    watch(editContext.mutatedOptions, (options) => {
      mutatedOptions.value = options;
    });
  }
  function queryBlocks(bundlesOrCallback, providedList) {
    const callback = typeof bundlesOrCallback === "function" ? bundlesOrCallback : (item) => {
      if (bundlesOrCallback.includes(item.bundle)) {
        return {
          include: true,
          continueChildren: true
        };
      }
      return {
        include: false,
        continueChildren: true
      };
    };
    return computed(() => {
      const matches = [];
      const list = providedList ? providedList : rootBlocks?.value;
      if (!list) {
        console.error(
          "[bl\xF6kkli] - Failed to inject rootBlocks in queryBlocks. Automatic injection is only available when the useBlokkliHelper composable is called in a component inside <BlokkliField>. If this is not the case, pass the FieldListItemTyped array as the second argument to queryBlocks."
        );
        return [];
      }
      walkBlocks(matches, callback, mutatedOptions.value, mutatedFields, list);
      return matches;
    });
  }
  return {
    queryBlocks
  };
}
